var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HotTable',{attrs:{"id":_vm.id,"settings":_vm.tableSettings,"data":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }